export const eligibility = {
  points: {
    eligibilitysavings: {
      description: [
        `Aged 18 and above; children aged 13 -17; in-trust: aged 1 month to 12 years<br><b>Malaysians</b> `,
        `From initial deposit<br><b>RM 20</b>`,
        `Joint Account<br><b>Maximum 2 persons</b>`,
        `A copy of: NRIC or Military ID or Police ID`,
        `For non-resident. Work permit, letters of appointment and passport`,
      ],
      title: "Eligibility",
    },

    eligibilitycurrent: {
      description: [
        `Aged 18 and above (Individual)<br><b>Malaysians and non-Malaysians</b> `,
        `Joint Account (Individual)<br><b>Maximum 2 persons</b>`,
        `Organisation (Non-individual) <br><b>Non-profit organisation, sole proprietorship, partnership, private limited and public listed company</b>`,
      ],
      title: "Eligibility",
    },

    eligibilitycommodityTD: {
      description: [
        `Aged 18 and above (Individual)<br><b>Malaysians</b> `,
        `Joint Account (Individual)<br><b>Maximum 2 persons</b>`,
        `In-trust<br><b>Aged 1 month up to 17 years old</b>`,
      ],
      title: "Eligibility",
    },

    eligibilitydebit: {
      description: [
        `Aged 18 and above (Individual)<br><b>Available to all alrajhi bank Malaysia Savings Account-i or Current Account-i holders age 18 and above</b>`,
      ],
      title: "Eligibility",
    },

    eligibilityrahafia: {
      description: [
        `Aged 18 old up to a maximum of 70 years old<br><b>Resident and non-resident individuals </b>`,
      ],
      title: "Eligibility",
    },

    requirementdeposit: {
      description: [`Minimum<br><b>Nominal amount of 1 million </b>`],
    },

    requirementforex: {
      description: [
        `Short dates transactions<br><b>Only i.e. T, T+1 or T+2</b>`,
        `Utilisation<br><b>For Shariah-compliant purposes only</b>`,
        `Account holder<br><b>Ringgit / Foreign currency with Al-Rajhi Bank</b>`,
      ],
    },

    eligibilitycurrentbiz: {
      description: [
        `Open<br><b>To Companies</b>`,
        `From initial deposit<br><b>RM500 or USD5,000 or its equivalent</b>`,
        `For Private Limited Companies:<br>
        <b><li>Certified copy of the Certificate of Incorporation (Form 49)</li>
          <li>Certified copy of the Return of Allotment of Shares (Form 24)</li>     
          <li>Certified copy of Memorandum and Articles of Association</li>
          <li>Certified copy of a Resolution to open the account</li>
          <li>Certified copy of a Board Resolution regulating conduct of the account</li>
          <li>Certificate by the Registrar of Company</li>
          <li>Certified copy of the Certificate of Registration</li>
          <li>Identity documents of all directors and signatories</li>
        </b>`,
      ],
    },

    eligibilitytdbiz: {
      description: [
        `Organization<br><b>Non-profit organization and Corporate Organization</b>`,
        `Minimum Initial deposit: Standard<br>
        <b><li>RM500 for placement if more than 3 months and above</li>
          <li>RM1,000 for placement less than 3 months</li>
        </b>`,
      ],
    },

    eligibilitybank: {
      description: [
        `On merit<br><b>On merit or case to case basis</b>`,
        `Enjoys financing facility<br><b>Customer who enjoys financing facility with the Bank</b>`,
      ],
    },
    eligibilitypf: {
      description: [
        `Salaried employees<br><b>Minimum age 25 years old</b>`,
        `Salaried employees<br><b>Maximum age 60 years old</b>`,
        `Minimum monthly income of<br><b>RM 5,000* & above</b>`,
      ],
    },
    eligibilitypftd: {
      description: [
        `Salaried employees<br><b>Minimum age 25 years old</b>`,
        `Salaried employees<br><b>Maximum age 65 years old</b>`,
        `Minimum monthly income of<br><b>RM 3,500* & above</b>`,
      ],
    },
    eligibilitypfccsp: {
      description: [
        `Salaried employees<br><b>Minimum age 25 years old</b>`,
        `Salaried employees<br><b>Maximum age 65 years old</b>`,
        `Minimum monthly income of<br><b>RM 3,500 - RM 6,000</b>`,
      ],
    },
    eligibilityumrah: {
      description: [
        `Pekerja bergaji<br><b>Umur Minimum – 25 tahun</b>`,
        `Pekerja bergaji<br><b>Umur Maksimum – 60 tahun</b>`,
        `Pendapatan Bulanan Minimum<br><b>RM5000* & ke atas</b>`,
      ],
    },
    eligibilityhomeone: {
      description: [
        `Salaried and Self-employed employees<br><b>Malaysian</b>`,
        `Salaried employees<br><b>Minimum age 21 years old</b>`,
        `Minimum gross income of<br><b>RM 3,000</b>`,
      ],
    },
    eligibilitybusiness: {
      description: [
        `<b>Malaysians and non-Malaysians (T&C apply)</b>`,
        `<b>Individual aged 21 years & up to 65 years</b>`,
      ],
    },
    eligibilitycashline: {
      description: [
        `Age<br><b>Minimum age 25 years old</b>`,
        `Income<br><b>Minimum gross monthly income: RM15,000* & above</b>`,
      ],
    },
  },
};
